export const FINANCIAL_STUDY_NODE = "financialStudy";
export const FINANCIAL_STUDY_DEFAULTS = { title: "Финансовый доклад", period: "latest" } as const;

export function normalizeFinancialStudyAttrs(value: unknown) {
  const raw = value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const title = typeof raw.title === "string" ? raw.title.replace(/[\u0000-\u001f\u007f]/g, " ").trim().slice(0, 180) : "";
  return { title: title || FINANCIAL_STUDY_DEFAULTS.title, period: typeof raw.period === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(raw.period) ? raw.period : "latest" };
}
